
export enum NegotiationOutcome {
  AcceptedBySeller= 'AcceptedBySeller',
  AcceptedByBuyer= 'AcceptedByBuyer',
  DeclinedBySeller= 'DeclinedBySeller',
  Expired= 'Expired',
  AbortedDueToAnotherAcceptance= 'AbortedDueToAnotherAcceptance',
  OfflineAccepted= 'OfflineAccepted',
  OfflineDeclined= 'OfflineDeclined',

}